module.exports = __webpack_public_path__ + "static/media/arrow-right-cyan.045a38af.svg";